export default __webpack_public_path__ + "static/media/Portfolio.cd77fc2a.jpg";